var _excluded = ["color", "children", "size"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Box } from '@grupoboticario/flora-react-box';
import { filterUndefined } from '@grupoboticario/flora-react-utils';
export var IconWrapper = /*#__PURE__*/React.forwardRef((_ref, forwardedRef) => {
  var {
    color = 'currentColor',
    children,
    size = 24
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var sizeProps = {
    width: size,
    height: size
  };
  var css = filterUndefined(_extends({}, props.css, {
    '& > svg, & path': {
      fill: color
    },
    display: 'inline-flex'
  }));
  return /*#__PURE__*/React.createElement(Box, {
    ref: forwardedRef,
    css: css,
    as: "span"
  }, /*#__PURE__*/React.cloneElement(children, _extends({}, children == null ? void 0 : children.props, props, sizeProps)));
});
//# sourceMappingURL=IconWrapper.js.map